"use client"
import { useState, useEffect, useRef } from "react"
import Input from "./Input/Input"

const SerialInput = ({ value, onChange, deviceType, label, disabled }) => {
  const inputRef = useRef(null)
  const isHub = label?.toLowerCase().includes("gateway") || deviceType === "Tenovi Hub"

  const formatValue = (val) => {
    if (isHub) {
      val = val.replace(/[^0-9a-fA-F]/g, "").slice(0, 12) 
      return val.match(/.{1,4}/g)?.join(" ") || val 
    } else {
      return val.replace(/\D/g, "").slice(0, 15) 
    }
  }

  const handleChange = (e) => {
    let rawValue = e.target.value
    const formatted = formatValue(rawValue)
    onChange(formatted.replace(/\s/g, "")) 
  }

  const displayedValue = formatValue(value || "")

  useEffect(() => {
    const input = inputRef.current
    if (input) {
      const pos = input.value.length
      input.setSelectionRange(pos, pos)
    }
  }, [displayedValue])

  return (
    <Input
      ref={inputRef}
      type="text"
      value={displayedValue}
      onChange={handleChange}
      disabled={disabled || !deviceType}
      placeholder={isHub ? "Enter 12 hex Gateway ID" : "Enter 15-digit IMEI"}
    />
  )
}

export default SerialInput